import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {Http, Response, RequestOptions, Headers, Request, RequestMethod,URLSearchParams, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


import { JwtService } from './jwt.service';

@Injectable()
export class ApiService {
  constructor(
    private http: Http,
    private jwtService: JwtService
  ) {}

  private setHeaders(headers: Object = {}): Headers {
    headers['Accept'] = 'application/json';

    if (this.jwtService.getToken()) {
      headers['Authorization'] = `Bearer ${this.jwtService.getToken()}`;
    }
    return new Headers(headers);
  }

  private setHeadersOfMultipartFormData(headers: Object = {}): Headers {
      headers['Accept'] = 'application/json';
      if (this.jwtService.getToken()) {
        headers['Authorization'] = `Bearer ${this.jwtService.getToken()}`;
      }
      return new Headers(headers);
  } 

  private formatErrors(error: any) {
    if (error.status == 401) {
      localStorage.clear();
      window.location.reload();
    }
     return Observable.throw(error.json());
  }

  get(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers: this.setHeaders({}), search: params })
    .catch(this.formatErrors)
    .map(this.extractData);
  }

  getRawImage(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { responseType: ResponseContentType.Blob, headers: this.setHeaders({}), search: params })
    .catch(this.formatErrors)
    .map(this.extractImageData);
  }

  getRawJson(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(`/assets/json/${path}`, { headers: this.setHeaders({}), search: params })
      .catch(this.formatErrors)
      .map(this.extractData);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeaders({}) }
    )
    .catch(this.formatErrors)
    .map(this.extractData);
  }

  post(path: string, body: Object = {}, headers: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeaders(headers) }
    )
    .catch(this.formatErrors)
    .map(this.extractData);
  }
  
  postLogin(path: string, body: Object = {}, headers: Object = {}): Observable<any> {
    return this.http.post(
       `${environment.api_url}${path}`,
      body,
      { headers: this.setHeaders(headers) }
    )
    .catch(this.formatErrors)
    .map(this.extractData);
  }

  postLogout(path: string, body: Object = {}, headers: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.token_url}${path}`,
      body,
      { headers: this.setHeaders(headers) }
    )
      .catch(this.formatErrors)
      .map(this.extractData);
  }

  // Multipart Service Start
   postMultipart(path: string, body: Object = {}, headers: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeadersOfMultipartFormData(headers) }
    )
    .catch(this.formatErrors)
    .map((res: Response) => res.json());
  }
  // Multipart Service End

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders({}) }
    )
    .catch(this.formatErrors)
    .map(this.extractData);
  }

  public extractData(res: Response) {
    try {
      return res.json();
    } catch (e) {
      return {};
    }
  }
  public extractImageData(res: Response) {
    try {
       return res;
    } catch (e) {
      return {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts